import { Helmet } from "react-helmet-async";

const SITE_NAME = "Acanthe Jardins";
const DEFAULT_DESC = "Acanthe Jardins, votre paysagiste expert en aménagement extérieur dans les Bouches-du-Rhône, le Var et le Vaucluse. Étude, conception, création et entretien d'espaces verts pour collectivités, entreprises et particuliers.";
const DEFAULT_IMG = "/logo-acanthe.png";

export default function Seo({ title, description, image, path = "", type = "website", jsonLd, noindex = false }) {
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const url = `${origin}${path}`;
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} — Vos experts en aménagement extérieur`;
  const desc = description || DEFAULT_DESC;
  const rawImg = image || DEFAULT_IMG;
  const img = rawImg.startsWith("http") ? rawImg : `${origin}${rawImg}`;
  const blocks = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : [];

  return (
    <Helmet>
      <html lang="fr" />
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}
      <link rel="canonical" href={url} />

      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta property="og:locale" content="fr_FR" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />

      {blocks.map((b, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(b)}</script>
      ))}
    </Helmet>
  );
}

export const localBusinessLd = () => ({
  "@context": "https://schema.org",
  "@type": "LandscapingBusiness",
  name: "Acanthe Jardins",
  image: DEFAULT_IMG,
  "@id": "https://acanthejardins.fr",
  url: typeof window !== "undefined" ? window.location.origin : "",
  telephone: "+33442690213",
  email: "contact@acanthejardins.fr",
  priceRange: "€€",
  address: {
    "@type": "PostalAddress",
    streetAddress: "665 Avenue du Raumartin",
    addressLocality: "Saint-Victoret",
    postalCode: "13730",
    addressCountry: "FR",
  },
  areaServed: ["Bouches-du-Rhône", "Var", "Vaucluse"],
  description: DEFAULT_DESC,
});
